import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolderOpenFront: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"folder-open-front"} maskId="square-filled-radius-0-stroke-1-IconFolderOpenFront"><path d="M21.9033 20H2.09863L0.128906 11H23.8701L21.9033 20Z" fill="currentColor"/><path d="M12.2002 5H22.001V10H2.00098V3H10.0889L12.2002 5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFolderOpenFront;
